import type { JSXElementConstructor } from 'react';

import { TFunction, translate, TValues } from '../util/translate';
import { useTranslation } from '../util/useTranslation';

export interface InterpolateProps {
  i18nKey: string;
  values?: TValues;
}

// Exported for testing
export const Interpolate = ({ i18nKey, values = {} }: InterpolateProps) => {
  const { t } = useTranslation();
  return <>{t(i18nKey, values)}</>;
};

export type InterpolateElement = React.ReactElement<InterpolateProps, JSXElementConstructor<InterpolateProps>>;

/**
 * T allows calling the translation system without calling a React hook.
 * This makes it useful for usage outside the render system.
 *
 * It can be used either as a tagged template literal:
 * ```
 * T`borrower.sector.label`
 * ```
 * or as a function:
 * ```
 * T('borrowers.count', { count: borrowers.length })
 * ```
 */
export const T: TFunction<InterpolateElement> = translate(
  (i18nKey: string, values?: TValues): InterpolateElement => (
    <Interpolate i18nKey={i18nKey} values={values} key={i18nKey} />
  )
);
